export default __webpack_public_path__ + "static/media/leaders_on_poachers.dde87c6f.jpg";